<template>
  <svg class="button__border-decor button__border-decor--left" width="13" height="42" viewBox="0 0 13 42" xmlns="http://www.w3.org/2000/svg"><path d="M13 0H6H3.6C1.61177 0 0 1.61178 0 3.6V34.6749C0 35.6296 0.632141 36.5453 1.75736 37.2204L7.96593 40.9456C9.09115 41.6207 10.6173 42 12.2086 42H13V41H12.2086C10.8825 41 10 41 9 40.5L2.5 36.5C1.56232 35.9374 1 35.4705 1 34.6749V4C1 2.34315 2.34315 1 4 1H6H13V0Z" /></svg>
</template>

<script>
export default {
  name: "MainButtonDecorLeftSmall",
};
</script>